// src/pages/financial-chat/components/ChatSuggestions.jsx
import React from 'react';

const suggestions = [
  "دلار چنده؟",
  "قیمت طلا امروز چند است؟",
  "قیمت آیفون ۱۷ چنده؟",
  "قیمت سکه امامی چقدره؟",
  "بیت کوین چند شد؟"
];

const ChatSuggestions = ({ onSuggestionClick, isLoading }) => {
  return (
    <div className="mb-[15vh] px-4 py-3 border-t border-gray-200 bg-gray-50">
      <div className="flex flex-wrap gap-2 justify-center max-w-4xl mx-auto">
        {suggestions.map((text, index) => (
          <button
            key={index}
            onClick={() => onSuggestionClick(text)}
            disabled={isLoading}
            className={`
              px-4 py-2 rounded-full text-sm font-medium transition-all
              bg-white border border-gray-300 text-gray-700
              hover:bg-blue-50 hover:border-blue-400 hover:text-blue-700
              disabled:opacity-50 disabled:cursor-not-allowed
              shadow-sm
            `}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatSuggestions;